import React, { useState } from "react";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "";
const makeEndpoint = (path = "/waitlist") =>
  API_BASE ? `${API_BASE.replace(/\/$/, "")}${path}` : path;

export default function WaitlistForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | success | error
  const [message, setMessage] = useState("");

  const validateEmail = (e) => {
    return /^\S+@\S+\.\S+$/.test(e);
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    setMessage("");
    if (!email || !validateEmail(email)) {
      setStatus("error");
      setMessage("Please enter a valid email address.");
      return;
    }

    setStatus("sending");

    try {
      const endpoint = makeEndpoint("/waitlist");
      const res = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email }),
      });

      // attempt to parse JSON safely
      const data = await res.json().catch(() => ({}));

      if (res.ok && data.ok) {
        setStatus("success");
        setMessage("Thanks — you're on the waitlist. Check your inbox for confirmation.");
        setEmail("");
      } else {
        setStatus("error");
        setMessage(data.error || `Submission failed (${res.status}). Please try again later.`);
      }
    } catch (err) {
      console.error("Network error:", err);
      setStatus("error");
      setMessage("Network error. Please try again.");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="waitlist-form"
      style={{
        maxWidth: 640,
        margin: "0 auto",
        textAlign: "center",
        color: "#000000",
        fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, 'Helvetica Neue', Arial",
      }}
    >
      <style>{`
        .waitlist-form input::placeholder { color: #94a3b8; opacity: 1; }
        .waitlist-form .input-row { display: flex; gap: 12px; align-items: center; justify-content: center; flex-wrap: nowrap; }
        @media (max-width: 560px) {
          .waitlist-form .input-row { flex-direction: column; }
        }
      `}</style>

      <label style={{ display: "block", marginBottom: 8 }}>
        <div className="input-row" style={{ marginTop: 6 }}>
          <input
            type="email"
            placeholder="Enter your email address to get notified"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              flex: 1,
              padding: "10px 12px",
              borderRadius: 8,
              border: "1px solid #334155",
              marginBottom: 0,
              boxSizing: "border-box",
              color: "#000000",
              background: "rgba(255,255,255,0.03)",
              minWidth: 0,
              outline: "none",
            }}
            aria-label="email"
          />

          <button
            type="submit"
            disabled={status === "sending"}
            style={{
              padding: "10px 16px",
              borderRadius: 8,
              cursor: status === "sending" ? "not-allowed" : "pointer",
              border: "none",
              background: "#000000",
              color: "white",
              fontWeight: 600,
              whiteSpace: "nowrap",
              minWidth: 160,
            }}
          >
            {status === "sending" ? "Sending…" : "Join the waitlist"}
          </button>
        </div>
      </label>

      {message && (
        <div
          role="status"
          style={{
            marginTop: 12,
            color: status === "success" ? "#86efac" : "#fca5a5",
            fontWeight: 500,
          }}
        >
          {message}
        </div>
      )}
    </form>
  );
}
